// extracted by mini-css-extract-plugin
export default {"hero":"Stellenangebote_hero__vy823","text":"Stellenangebote_text__UNkuJ"};